import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have this function for logging
import axios from "axios";
import { fileOpen } from "browser-fs-access"; // Used for file picker

const sendOrgSignature = async (
  file,
  name,
  org_id,
  istampon,
  token,
  prefix
) => {
  try {
    // Select image file using file picker

    if (file) {
      // get bytes by downloading the file from the URL
      const response_file = await fetch(file.url);
      if (!response_file.ok) {
        throw new Error(`Failed to fetch file: ${response_file.statusText}`);
      }
      const blob = await response_file.blob();

      const fileName = file.name;

      const url = prefix + "upload/signatures";

      // Create a new FormData object
      const formData = new FormData();
      formData.append("file", blob, fileName); // Append the file
      formData.append("name", name); // Append oid field
      formData.append("org_id", org_id); // Append oid field
      formData.append("istampon", istampon); // Append istampon field

      // add Authorization header

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      // Send the POST request using axios with headers
      const response = await axios.post(url, formData, { headers });

      // Send the POST request using axios

      const auth = getAuthCentral();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        console.error("User not logged in");
        return "";
      }

      const db = getFirestore();
      const userRef = doc(db, "user", currentUser.uid);
      const userSnapshot = await getDoc(checkDB(userRef));

      if (!userSnapshot.exists()) {
        console.error("User document not found");
        return "";
      }

      org_id = userSnapshot.get("org_id");
      const responseText = response.data;

      // Log the request and response
      await addLogDocument(
        url,
        prefix,
        userRef, // Log the userRef ID
        org_id,
        response.status.toString(),
        "", // folderid
        "", // docid
        formData.toString(), // Log formData
        responseText,
        "POST"
      );

      // Check response status
      if (response.status === 200) {
        const jsonResponse = responseText;

        // Extract and return the URL from the response
        const returnedUrl = jsonResponse.url;
        return returnedUrl;
      } else {
        console.error(`Error response: ${response.status}`);
        return "";
      }
    } else {
      // File selection was canceled
      return "";
    }
  } catch (error) {
    console.error(`Error selecting/uploading file: ${error.message}`);
    return "";
  }
};

export default sendOrgSignature;
